import RecruitDetails from '../details';

const AddRecruitDetails = () => {
	return <RecruitDetails id="" isAddingDetails={true} />;
};
export default AddRecruitDetails;
